import React, {Component, useState} from 'react'
import classnames from 'classnames'
import {getOffsetPostion, getScrollParent} from "../../lib/DomUtils";
import {humanReadableDate, parseDateTimeString} from "../../lib/DateUtils";


function SimpleListItem(props) {
  const { item, onDelete, onSelect } = props;

  const [openSummary, setOpenSummary] = useState(false);
  const [summaryPosition, setSummaryPosition] = useState({
    left: 0,
    top:0
  });

  function handleTitleEnter(e) {
    const targetPosition = getOffsetPostion(e.target);
    const scrollParent = getScrollParent(e.target.offsetParent);

    const scrollTop = scrollParent ? scrollParent.scrollTop : 0;

    setOpenSummary(true);
    setSummaryPosition({
      top: targetPosition.top + 28 - scrollTop,
      left: targetPosition.left
    });
  }

  function handleTitleLeave() {
    setOpenSummary(false);
  }

  function renderDate() {
    if (item.date) {
      return humanReadableDate(item.date * 1000);
    } else {
      return humanReadableDate(parseDateTimeString(item.updatedAt))
    }
  }

  return (
    <div className={'info_editor'}>
      <dt>
        {renderDate()}
      </dt>

      <dd className={classnames({'hover': openSummary})}>
        <a className={'link_info'} onMouseEnter={handleTitleEnter} onMouseLeave={handleTitleLeave} onClick={e => onSelect(item)}>
          {item.title? item.title : '제목 없음'}
        </a>

        {onDelete && <button type={'button'} className={'mce-ico ico_trash'} onClick={e => onDelete(item)}>삭제</button>}

        <div className={'layer_info'} style={summaryPosition}>
          <div className={'inner_layer'}>
            {item.summary || '[내용 없음]'}
          </div>
        </div>
      </dd>
    </div>
  )
}

export default function SimpleList(props) {
  const { list, onDelete, onSelect } = props;
  return (
    <div className={'wrap-simple-list'}>
      <div className={'simple-list'}>
        {list.map(item => <SimpleListItem key={item.sequence || item.id} item={item} onDelete={onDelete} onSelect={onSelect} />)}
      </div>
    </div>
  )
}
